export enum LIMIT_USAGES_STATUS {
  NORMAL = "normal",
  WARNING = "warning",
  ERROR = "error",
}
